import { Paragraph } from '../Paragraph';
import classes from './Description.module.css';

type DescriptionProps = {
  description: string;
  id: string;
  size: 'sm' | 'md' | 'ml' | 'lg';
};

export const Description = ({ description, id, size }: DescriptionProps) => {
  return (
    <Paragraph size={size} id={id} className={classes.description}>
      {description}
    </Paragraph>
  );
};
